import React, { FC, PropsWithChildren } from 'react';

import { DataLayerWrapper } from 'src/components/data-layer-wrapper/data-layer-wrapper';
import { selectSelectedAccount } from 'src/state/account/selectors';
import { selectSelectedProduct } from 'src/state/order/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { DataLayerUtils } from 'src/utils/data-layer-utils';

interface Props {
  errorMessage: string;
}

export const DataLayerErrorWrapper: FC<PropsWithChildren<Props>> = (props) => {
  const { errorMessage, children } = props;
  const account = useAppSelector(selectSelectedAccount);
  const selectedProduct = useAppSelector(selectSelectedProduct);

  return (
    <DataLayerWrapper
      pushToDataLayer={() => DataLayerUtils.setEcomErrorDataLayer(errorMessage, account?.partnerId, selectedProduct)}
    >
      {children}
    </DataLayerWrapper>
  );
};
